<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Facturas globales de clínicas</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Fact_global</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Búsqueda de facturas
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Fecha</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-datepicker name="nombre" placeholder="Fecha" :disabled="loader"
                                     :max="fechaMaxima"
                                     v-model="fecha" @input="fechaSeleccionadaClick"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

           <b-col class="text-right" v-if="$localStorageService.can('Excel_01_admin_factura')">
                <download-excel
                    v-if="datosTabla.length > 0"
                    class="btn btn-primary"
                    :data="datosTabla"
                    :fields="fieldsExcel"

                    worksheet="My Worksheet"
                    :name="'factura_globales_clinica'+$formatoFecha(new Date())+'.xls'"
                >
                  Generar Excel
                  <em class="fa fa-file-excel-o"></em>
                </download-excel>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(corte)="row">
              <b-badge v-if="row.item.corte" variant="primary">Si</b-badge>
              <b-badge v-else variant="danger">No</b-badge>
            </template>
            <template v-slot:cell(facturado)="row">
              <b-badge v-if="row.item.facturado" variant="primary">Si</b-badge>
              <b-badge v-else variant="danger">No</b-badge>
            </template>
            <template v-slot:cell(ingreos)="row">
              {{row.item.ingreos | moneda}}
            </template>
            <template v-slot:cell(facturaPacientes)="row">
              {{row.item.facturaPacientes | moneda}}
            </template>
            <template v-slot:cell(factura)="row">
              {{row.item.factura | moneda}}
            </template>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    v-if="row.item.facturado"
                    title="Realizar Corte"
                    size="sm"
                    v-b-tooltip.hover.top="'Imprimir Factura'"
                    :disabled="row.item.loaderImpresion"
                    @click="imprimirFactura(row.item)"
                    variant="outline-primary"
                >
                  <font-awesome-icon  v-if="row.item.loaderImpresion === false" icon="print" />
                  <b-spinner v-else small></b-spinner>
                </b-button>
                <b-button
                    v-if="row.item.facturado === false"
                    title="Facturar"
                    v-b-tooltip.hover.top="'Facturar'"
                    size="sm"
                    :disabled="row.item.loadFactura"
                    @click="facturar(row.item)"
                    variant="outline-primary"
                >
                  <font-awesome-icon v-if="!row.item.loadFactura" icon="file-invoice" />
                  <b-spinner v-if="row.item.loadFactura" small></b-spinner>
                </b-button>
                <b-button
                    v-if="row.item.corte === false"
                    title="Realizar Corte"
                    size="sm"
                    v-b-tooltip.hover.top="'Realizar Corte'"
                    :disabled="row.item.loadCorte"
                    @click="guardarCorte(row.item)"
                    variant="outline-primary"
                >
                  <font-awesome-icon  v-if="!row.item.loadCorte" icon="cash-register" />
                  <b-spinner v-if="row.item.loadCorte" small></b-spinner>
                </b-button>

              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>


      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";
import * as JSZip from "jszip";
import { saveAs } from 'file-saver'
export default {
  name: "FacturasCorteCaja",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        {key: "idClinica", label: "ID", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "corte", label: "Realizó corte", sortable: true},
        {key: "facturado", label: "Facturó", sortable: true},
        {key: "ingreos", label: "Ingreso", sortable: true},
        {key: "facturaPacientes", label: "Cantidad facturado por px", sortable: true},
        {key: "factura", label: "Factura global", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 15,
      paginaActual: 0,
      loaderAcciones: false,
      loader: false,
      fecha: null,
      fieldsExcel: {
        "ID": "idClinica",
        "Clínica": "clinica",
        "Realizó corte": "corte",
        "Facturó": "facturado",
        "Ingreso": "ingreos",
        "Cantidad facturado por px": "facturaPacientes",
        "Factura global": "factura"
      },
      horasDiferencia: null,
      fechaMaxima: null,
    }
  },
  async created() {
    await this.obtenerFechaReal();
    this.horasDiferencia = this.$localStorageService.getClinicaActualHorasDiferencia();
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    /**
     *  Metodo que manda a llamar el servicio "diagnostico/obtener/CorteCaja" el cual obtiene los datos que se mostraran en la vista
     *
     *  La fecha se envia en "crudo" esto significa que la fecha enviada al back es el dato tal cual lo recibe del datepicker sin modificaciones
     *  El back se encargara del formato
     */
    async obtenerDatos() {
      this.loader = true;
      this.datosTabla = [];
      const parametros = {fechaInicio: this.fecha.split("T")[0]}
      await   this.$http
          .post(this.$api + "diagnostico/informacion-corte", parametros)
          .then((response) => {
            if (response.data.data) {
              response.data.data.map(value => {
                value.loadFactura = false;
                value.loaderImpresion = false;
                this.datosTabla.push(value)
              })
            }
          }).finally(()=> {
        this.loader = false;
      });

    },
    /**
     *  Metodo que manda a llamar el servicio de guardado para el corte de caja
     *
     *  La fecha se envia en "crudo" esto significa que la fecha enviada al back es el dato tal cual lo recibe del datepicker sin modificaciones
     *  El back se encargara del formato
     */
    guardarCorte(item) {
      item.loadCorte = true;
      const envio = {
        idClinica: item.idClinica,
        total: item.ingreos,
        comentario: 'Corte guardado desde el modulo de administracion de cortes',
        fecha: this.fecha.split("T")[0]
      }
      this.$http
          .post(this.$api + "diagnostico/guardar/CorteCaja", envio)
          .then((response) => {
            if (response.data.data) {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Corte de caja guardado correctamente",
              });
              item.corte = true;
            }
          }).finally(item.loadCorte = false);
    },
    facturar(item) {
      if (item.factura > 0) {
        item.loadFactura = true
        const envio = {
          idRecibo: null,
          idDatosFiscales: null,
          cfdi: "P01",
          idClinica: item.idClinica,
          horas: this.horasDiferencia,
          fecha: this.fecha.split("T")[0],
          fechaFin: null,
          cantidadGlobal: item.factura
        };
        this.$http.post(this.$api + 'facturacion/facturaGlobal', envio).then(respuesta => {
          if (respuesta.data.data) {
            if (respuesta.data.data.includes('exito')) {
              const mensaje = respuesta.data.data;
              const array = mensaje.split("|");
              item.idFactura = array[1];
              item.facturado = true;
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Se generó la factura correctamente",
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: respuesta.data.data,
              });
            }
          }
        }).finally(() => {
          item.loadFactura = false
        })
      } else {
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: 'La cantidad a facturar debe ser mayor a $0',
        });
      }
    },
    imprimirFactura(item) {
      item.loaderImpresion = true;
      const parametros = {idFactura: item.idFactura}
      this.$http
          .post(this.$api + "reportes/factura/erp", parametros)
          .then((respuesta) => {
            if (respuesta.data.data === null ){
              this.facturaAntigua(item)
            }else {
              window.open(respuesta.data.data);
            }
          }).finally(() => {
        item.loaderImpresion = false
      })
    },
    facturaAntigua(item){
      item.loaderImpresion = true;
      this.$http.get(this.$api + 'reportes/factura?idFactura=' + item.idFactura).then(respuesta => {
        if (respuesta.data.data) {
          const datos = respuesta.data.data
          this.descargarFactura(datos)
        }
      }).finally(() => {
        item.loaderImpresion = false
      })
    },
    descargarFactura(datos){
      const pdf =datos.pdf;
      const xml =datos.xml;
      const folio =datos.uid;
      const zip = new JSZip();
      zip.file(folio+".xml", xml, {base64: false});
      zip.file(folio+".pdf", pdf, {base64: true});
      zip.generateAsync({type:"blob"})
          .then(function(content) {
            saveAs(content, folio+".zip");
          });
    },
    /**
     * Método que se ejecuta cuando se selecciona una fecha en el datepicker
     * Actualiza el valor de la fecha de búsqueda limpiando primero el valor anterior
     * @param event - Fecha seleccionada del datepicker
     */
    fechaSeleccionadaClick(event) {
      this.fecha = null;
      this.fecha = new Date(event).toISOString();
      this.obtenerDatos()
    },
    /**
     * Obtiene la fecha actual del servidor para establecer la fecha máxima permitida
     * y la fecha de búsqueda inicial del corte de caja
     * @returns {Promise<void>} Promesa que se resuelve cuando se obtiene la fecha del servidor
     */
    async obtenerFechaReal() {
      await this.$http
          .get(this.$api + "diagnostico/fechaActual/CorteCaja")
          .then((respuesta) => {
            if (respuesta.data.data) {

              let fechaMaximaAux = new Date(respuesta.data.data);

              // Restar 1 día
              fechaMaximaAux.setDate(fechaMaximaAux.getDate() - 1);

              // Convertir a ISO
              let fechaISO = fechaMaximaAux.toISOString();

              this.fechaMaxima = fechaISO;

            }
          });
    },

  }
}
</script>

<style scoped>

</style>
